// Come si collega il wallet da telefono, e perché così.
//
// Su desktop Phantom è un'estensione: inietta `window.phantom` e l'adapter la
// trova. Su telefono le estensioni non esistono, quindi Safari e Chrome non
// iniettano niente e l'adapter conclude — correttamente — che Phantom non c'è.
// Il pulsante standard porta allora alla pagina di download, anche a chi l'app
// ce l'ha già installata.
//
// COME CI SI COLLEGA DA TELEFONO
//
// Il Mobile Wallet Adapter di Solana e' la via ufficiale su Android, ed e'
// collegato in App.js — ma **Phantom non lo implementa**: nell'elenco dei
// wallet compatibili non compare, verificato sul telefono. Serve quindi a chi
// usa Solflare o altri, non a chi usa Phantom, che e' la maggioranza. Su iOS
// MWA non esiste affatto.
//
// Per Phantom restano le sue due strade, ed entrambe hanno un limite:
//
//   DEEPLINK (lib/phantomDeeplink.js) — il gioco resta in Safari o Chrome e
//   Phantom si apre come app. E' la strada principale. La firma ha risposto a
//   lungo `-32603 Unexpected error`; il sospetto rimasto, dopo aver escluso
//   tutto il resto, e' che chiedessimo `cluster=devnet` a un'app senza Testnet
//   Mode acceso. Ora il cluster non lo mandiamo piu': firmare un messaggio e'
//   off-chain e la rete non c'entra.
//
//   BROWSER INTERNO (`apriInPhantom`, qui sotto) — il provider viene iniettato
//   e tutto funziona come sul desktop, ma quella webview non ruota e VEXEL e'
//   orizzontale. Ruotare il contenuto via CSS e' stato provato e abbandonato:
//   ogni correzione ne scopriva un'altra, perche' tutto cio' che tocca
//   coordinate deve sapere della rotazione. Resta come ripiego per il vault.

// iPadOS 13+ si dichiara "Macintosh" nello user agent: senza il controllo sul
// touch, un iPad verrebbe trattato come un desktop e resterebbe bloccato.
export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export function hasInjectedProvider() {
  if (typeof window === 'undefined') return false;
  const phantom = window.phantom && window.phantom.solana;
  if (phantom && phantom.isPhantom) return true;
  return Boolean(window.solana && window.solana.isPhantom);
}

// Vero su qualunque telefono in un browser normale, Android compreso.
//
// Il Mobile Wallet Adapter non basta a escluderlo: MWA e' la via ufficiale su
// Android, ma **Phantom non lo implementa** — il suo elenco di wallet
// compatibili non la contiene, verificato sul campo. Chi ha Phantom su Android
// ha quindi bisogno dei deeplink esattamente come chi sta su iPhone. MWA resta
// collegato in App.js perche' serve a chi usa un wallet che lo supporta.
//
// Dentro il browser di Phantom il provider c'è, quindi qui torna falso e si usa
// il percorso di sempre.
export function needsPhantomBrowser() {
  return isMobile() && !hasInjectedProvider();
}

// Quale browser sta usando il giocatore ORA. Serve al viaggio di ritorno: la
// pagina aperta dentro Phantom non ha modo di indovinare da dove è arrivata —
// lì lo user agent è quello della webview di Phantom — quindi glielo diciamo
// noi, passandolo nell'indirizzo (vedi `apriPhantomPerFirmare`).
//
// L'ordine dei controlli non è alfabetico ed è obbligatorio: Edge, Samsung
// Internet e Firefox su iOS si dichiarano tutti anche "Chrome" o "Safari", e
// chi cerca Chrome per primo li raccoglie tutti per sbaglio.
export function browserCorrente() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent;
  if (/EdgiOS|EdgA|Edg\//.test(ua)) return 'edge';
  if (/SamsungBrowser/.test(ua)) return 'samsung';
  if (/FxiOS|Firefox/.test(ua)) return 'firefox';
  if (/CriOS|Chrome/.test(ua)) return 'chrome';
  if (/Safari/.test(ua)) return 'safari';
  return null;
}

export function phantomBrowseUrl(target) {
  const url = target || window.location.href;
  // `ref` è richiesto da Phantom e identifica il sito che ha aperto il link.
  const ref = window.location.origin;
  return `https://phantom.app/ul/browse/${encodeURIComponent(url)}?ref=${encodeURIComponent(ref)}`;
}

export function apriInPhantom() {
  window.location.href = phantomBrowseUrl();
}
